import { createAction, props } from '@ngrx/store';
import { OverviewEntity } from '../../models/overview.entities';

//-- AEM Content
export const loadAEMContent = createAction(
  '[SkyMiles Overview/AEM] Load AEM Common Content'
);

export const loadAEMContentSuccess = createAction(
  '[SkyMiles Overview/AEM] Load AEM Common Content Success',
  props<{ aemContent: OverviewEntity }>()
);

export const loadAEMContentFailure = createAction(
  '[SkyMiles Overview/AEM] Load AEM Common Content Failure',
  props<{ aemContentError: OverviewEntity }>()
);

//-- AEM Summary Content
export const loadAEMSummaryContent = createAction(
  '[SkyMiles Overview/AEM] Load AEM Summary Content'
);

export const loadAEMSummaryContentSuccess = createAction(
  '[SkyMiles Overview/AEM] Load AEM Summary Content Success',
  props<{ aemSummaryContent: OverviewEntity }>()
);

export const loadAEMSummaryContentFailure = createAction(
  '[SkyMiles Overview/AEM] Load AEM Summary Content Failure',
  props<{ aemSummaryContentError: OverviewEntity }>()
);

//-- AEM Feature Flags
export const loadAEMFeatureFlags = createAction(
  '[SkyMiles Overview/AEM] Load AEM Feature Flags'
);

export const loadAEMFeatureFlagsSuccess = createAction(
  '[SkyMiles Overview/AEM] Load AEM Feature Flags Success',
  props<{ aemFeatureFlags: OverviewEntity }>()
);

export const loadAEMFeatureFlagsFailure = createAction(
  '[SkyMiles Overview/AEM] Load AEM Feature Flags Failure',
  props<{ aemFeatureFlagsError: OverviewEntity }>()
);

//-- AEM Welcome Tour
export const loadAEMWelcomeTour = createAction(
  '[SkyMiles Overview/AEM] Load AEM Welcome Tour'
);

export const loadAEMWelcomeTourSuccess = createAction(
  '[SkyMiles Overview/AEM] Load AEM Welcome Tour Success',
  props<{ aemWelcomeTour: OverviewEntity }>()
);

export const loadAEMWelcomeTourFailure = createAction(
  '[SkyMiles Overview/AEM] Load AEM Welcome Tour Failure',
  props<{ aemWelcomeTourError: OverviewEntity }>()
);

//-- AEM Error Messages
export const loadAEMErrorMessages = createAction(
  '[SkyMiles Overview/AEM] Load AEM Error Messages'
);

export const loadAEMErrorMessagesSuccess = createAction(
  '[SkyMiles Overview/AEM] Load AEM Error Messages Success',
  props<{ aemErrorMessages: OverviewEntity }>()
);

export const loadAEMErrorMessagesFailure = createAction(
  '[SkyMiles Overview/AEM] Load AEM Error Messages Failure',
  props<{ aemErrorMessagesError: OverviewEntity }>()
);
